"use strict";
// Copyright (c) Jupyter Development Team.
// Distributed under the terms of the Modified BSD License.
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(require("./htmlmanager"));
exports.version = require('../package.json').version;
function generateEmbedScript(widgetState, imageDataUrl) {
    return [
        '<img src=' + imageDataUrl + ' class="jupyter-widget">',
        '<script type="application/vnd.jupyter.widgets-state+json">' + JSON.stringify(widgetState) + '</script>'
    ].join('\n');
}
exports.generateEmbedScript = generateEmbedScript;
